import { RouteComponentProps } from 'react-router-dom'
import GpxForm from './GpxForm'

interface BalladPageProps extends RouteComponentProps<{}> {}
function GpxFormContainer(props: BalladPageProps) {
  return (
    <GpxForm
      onSuccess={() => {
        props.history.push(`/admin/gpx`)
      }}
    />
  )
}

export default GpxFormContainer
